module.exports = __webpack_public_path__ + "static/media/book-reader.cd826ecb.svg";